import script from "./WhereWeAre.vue?vue&type=script&setup=true&lang=js"
export * from "./WhereWeAre.vue?vue&type=script&setup=true&lang=js"

import "./WhereWeAre.vue?vue&type=style&index=0&id=13fc3598&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13fc3598"]])

export default __exports__